export default "__VITE_ASSET__kAO8lVSI__"